import { Outlet } from "react-router-dom";
import { Layout } from "./components/Layout";
import { useSession } from "./hooks/useSession";

// Top-level shell kept for clarity; the router is mounted in main.tsx.
export default function App() {
  // Trigger anonymous login on first mount; safe to call unconditionally.
  useSession();

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
